import { Icon } from '@ur-solutions/react-components'
import { TimeAddons } from './TimeAddons'
import { useForm, useTranslate } from '@ur-solutions/react-hooks'
import styled from 'styled-components'
import { TimeOverrides } from './TimeOverrides'
import { FixedAddons } from './FixedAddons'

const H2 = styled.h2`
  grid-column: 1 / -1;
  display: flex;
  width: 100%;

  margin: 1rem 0 0 8px;
  font-weight: 600;

  div {
    margin-left: 1rem;
  }

  cursor: default;
`

const Wrapper = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem 0;
`

interface AddonOverviewProps {
  userId: string
  datetimeStart: Date
  datetimeEnd: Date
}

export const AddonOverview: React.CFC<AddonOverviewProps> = ({
  userId,
  datetimeStart,
  datetimeEnd,
}) => {
  const translations = useTranslate({
    salaryConfiguration: 'salary.configuration',
    addonsAndChange: 'salary.addons-and-change',
  })

  const { formValues: filter, formChangeHandler: handler } = useForm({
    values: {
      open: false,
    },
    config: {
      storage: {
        storeFormState: true,
        sessionStorage: true,
        retrieveFormStateOnMount: true,
        storeFormStateName: 'firmadok__activities-salary-open-filter',
        transformValues: {
          open: value => {
            return typeof value === 'boolean' ? value : false
          },
        },
      },
    },
  })
  return (
    <Wrapper>
      <H2 onClick={() => handler('open')(!filter.open)}>
        {translations.addonsAndChange}
        <Icon
          size="1.25rem"
          margin="0.25rem 0 0 1rem"
          icon={filter.open ? 'chevron-down' : 'chevron-left'}
        />
      </H2>
      {filter.open && (
        <>
          <TimeAddons
            datetimeStart={datetimeStart}
            datetimeEnd={datetimeEnd}
            userId={userId}
          />
          <TimeOverrides
            datetimeStart={datetimeStart}
            datetimeEnd={datetimeEnd}
            userId={userId}
          />
          <FixedAddons
            datetimeStart={datetimeStart}
            datetimeEnd={datetimeEnd}
            userId={userId}
          />
        </>
      )}
    </Wrapper>
  )
}
